// extracted by mini-css-extract-plugin
export default {"header":"Landing_header__u8lmQ","linear":"Landing_linear__8xgQa","box":"Landing_box__gpXjy","ellipse":"Landing_ellipse__aQejj"};